import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="col00">
            <div class="heading01 type01">
                <h1>{{ 'Manage questions' | translate }}</h1>
                <forms-questions-actions></forms-questions-actions>
            </div>
            <ul class="tabs01">
                <li>
                    <a ui-sref="authorized.forms.questions.pools.list()" ng-class="{ active: vm.$state.includes('authorized.forms.questions.pools') }">
                        {{ 'Question pools' | translate }}
                    </a>
                </li>
                <li>
                    <a ui-sref="authorized.forms.questions.poolless.list()" ng-class="{ active: vm.$state.includes('authorized.forms.questions.poolless') }">
                        {{ 'Questions without pool' | translate }}
                    </a>
                </li>
                <li>
                    <a ui-sref="authorized.forms.questions.all.list()" ng-class="{ active: vm.$state.includes('authorized.forms.questions.all') }">
                        {{ 'All questions' | translate }}
                    </a>
                </li>
            </ul>
            <ui-view></ui-view>
            <!--<ul class="actions01 todo">-->
                <!--<li><a class="btn main">{{ 'Export questions' | translate }}</a></li>-->
            <!--</ul>-->
        </div>
    `
})
export default class {
    constructor ($state) {
        this.$state = $state;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/index.js